import { gql } from "@apollo/client";
/**
 * Anchor identity for {@link StandardizedFungibleToken} list/feed surfaces.
 * Required anywhere list data is hydrated via `extractStandardizedFungibleToken`
 * and then passed to `bullrunTokenMarketingPath` without a detail fetch.
 * Matches the `anchorToken` selection on category browse and search queries.
 */
export const STANDARDIZED_FUNGIBLE_TOKEN_ANCHOR_FIELDS = gql `
  fragment StandardizedFungibleTokenAnchorFields on StandardizedFungibleToken {
    anchorToken {
      address
      platformId
      currency {
        asset {
          symbol
          name
        }
        decimals
        logoUrl
      }
    }
  }
`;
/**
 * Polymarket event slug for {@link StandardizedPredictionEvent} list/feed surfaces.
 * Required anywhere list data is passed to `bullrunPredictionEventMarketingPath`
 * without a detail fetch.
 */
export const STANDARDIZED_PREDICTION_EVENT_NAVIGATION_FIELDS = gql `
  fragment StandardizedPredictionEventNavigationFields on StandardizedPredictionEvent {
    slug
  }
`;
